module.exports = "/_next/static/images/SelfServeAnalytics-4c2b4304c760ec786a718b37c22c256e.webp";